export const state = () => ({
  carts: true,
  profile: true
})

export const mutations = {
  setCarts (state, carts) {
    state.carts = carts
  },
  setProfile (state, profile) {
    state.profile = profile
  }
}
